import React from 'react';
import styles from'./nominate.module.css';

import { BsCheckCircle } from 'react-icons/bs';


const NominateModal = () => {
  return (
    <div className={styles.cardmodalwrapper}>
        <div className={styles.cardtextwrapper}>
            <h1>Success</h1>
            <h3>Nomination has been submitted successfully</h3>
            <h4>Thanks</h4>
        </div>
        <div className={styles.successimagewrapper}>
            <BsCheckCircle size={100} color="green"/>
        </div>
        <div className={styles.buttonwrapper}>
              <button>
              <a href='https://www.enjoynigeriaexpo.com/' alt='home'> Go back to the page</a>
                 
              </button>  
        </div>
    </div>
  )
}

export default NominateModal